module.exports = __webpack_public_path__ + "img/logo-fr.372fbab5.svg";